var map = {
	"./foto-guitarra.jpg": "96f8",
	"./guitarra-1.jpg": "40a1",
	"./guitarra-2.jpg": "1ab9",
	"./hada.jpg": "0837",
	"./noche-1.jpg": "e5df",
	"./noche-2.jpg": "602f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b5a1";